import React, {useEffect, useRef, useState} from 'react'
import { Link } from 'react-router-dom';
import bg19 from '../../../assets/images/background/bg-19.png'
import {getDatabase, onValue, ref, orderByChild, off, child, equalTo} from "firebase/database";
import bg22 from "../../../assets/images/background/bg-22.png";
import menulikor from "../../../assets/images/resource/likor_617x439.jpg";



function Likor() {
    const [iletisimVeriler, setIletisimVeriler] = useState({});
    const [currentId, setCurrentId]=useState('');

    useEffect(() => {
        const yemeklerRef = ref(getDatabase(),'iletisim');
        onValue(yemeklerRef, (snapshot) => {
            if(snapshot.exists()){
                const data = snapshot.val();
                const filteredData = {};
                Object.keys(data).forEach((key) => {
                    if (data[key].kategori === 'Likör') {
                        filteredData[key] = data[key];
                    }
                });
                setIletisimVeriler(filteredData);
            }
            console.log(iletisimVeriler);
        });
    }, []);


    return (
        <>

            <section id="likor" className="menu-one">
                <div className="left-bg"><img src={bg22} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>liquer</span></div>

                        <div className="pattern-image">
                            <img src={require('../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Likör</h2>
                    </div>

                    <div className="row clearfix">
                        <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menulikor} alt="" /></div>
                            </div>
                        </div>
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">

                                {Object.keys(iletisimVeriler).map(id=>{
                                    return <div className="dish-block" key={id}>
                                        <div className="inner-box">
                                            <div className="title clearfix"><div className="ttl clearfix"><h5><Link to="#">{iletisimVeriler[id].isim}</Link></h5></div><div className="price"><span>{iletisimVeriler[id].fiyat}</span><i
                                                className="fa-regular fa-turkish-lira-sign fa-2xs align-baseline"></i></div></div>
                                            <div className="text desc"><Link to="#">{iletisimVeriler[id].detay}</Link></div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="title-box centered">

                    <div className="text desc"><p>* Belirli Bir Yiyeceğe alerjiniz varsa lütfen servis personeline belirtiniz.<br/>
                        ( Please inform tour order-taker of any allergy or special dietary reguirements that
                        we should be made aware of,when preparing your menü request.)</p>
                        <p>**  Fiyatlar TL olup, KDV Dahildir.<br/>( All prices are in TL and inclusive of VAT.)</p>
                        <p>*** Siparişinize % 10 Servis Ücreti Eklenecektir.<br/>
                            ( % 10 Service Charge will be applied to your order.)</p>
                    </div>

                </div>
            </section>

        </>
    )
}

export default Likor